import { createContext } from 'react';

export type BatchTransactionCtx = {
  showBatchTransactionErrorAlert: boolean;
  batchTransactionError: string;
};

const BatchTransactionDialogueContext = createContext<BatchTransactionCtx>({
  showBatchTransactionErrorAlert: false,
  batchTransactionError: '',
});

export default BatchTransactionDialogueContext;